import { createFileRoute } from "@tanstack/react-router";
import { CityServiceCostPage, buildCityServiceCostHead } from "@/components/CityServiceCostPage";

export const Route = createFileRoute("/pueblo-seo-cost")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => buildCityServiceCostHead("pueblo", "seo"),
  component: () => <CityServiceCostPage city="pueblo" service="seo" />,
});
